import { Grid } from "@material-ui/core";
import { useEffect, useState } from "react";
import { Button, FormDataConsumer, RadioButtonGroupInput, required, SaveButton, SimpleForm, Toolbar, useDataProvider } from "react-admin";
import { useForm } from "react-final-form";
import { PopupboxManager } from "react-popupbox";

const useFreeIcons = (typeId) => {
  const dataProvider = useDataProvider();
  const [freeIcons, setFreeIcons] = useState([]);

  useEffect(() => {
    dataProvider.getIMIconsByPackTypeId(typeId).then(({ data }) => {
      setFreeIcons(data);
    });
  }, [typeId]);

  return { freeIcons };
};

const usePaidIconPacks = (typeId) => {
  const dataProvider = useDataProvider();
  const [paidIconPacks, setPaidIconPacks] = useState([]);

  useEffect(() => {
    dataProvider
      .getList("im-paid-icon-packs", {
        filter: { type: typeId, enabled: true },
      })
      .then(({ data }) => {
        // const filteredIcons = data.filter((icon) => icon.type == typeId);
        setPaidIconPacks(data);
      });
  }, [typeId]);

  return { paidIconPacks };
};

const useIconPackTypes = () => {
  const dataProvider = useDataProvider();
  const [types, setTypes] = useState([]);

  useEffect(() => {
    dataProvider.getIconPackTypes().then(({ data }) => {
      setTypes(data);
    });
  }, []);

  return { types };
};

const FreeIconGrid = ({ typeId, typeName, popupForm }) => {
  const { freeIcons } = useFreeIcons(typeId);

  return (
    <Grid container spacing={1} fullWidth>
      {freeIcons.map((icon) => {
        const imageUrl = icon.image_url;
        return (
          <Button
            key={icon.id}
            onClick={() => {
              var oldData = popupForm.getState().values.selected_icons ?? [];
              var newData = [...oldData];

              var shouldAdd = true;
              //Delete the icon if already added before
              for (var i = 0; i < newData.length; i++) {
                const d = newData[i];
                if (d.id == icon.id) {
                  shouldAdd = false;
                  newData.splice(i, 1);
                  break;
                }
              }
              //Add the icon if not added before
              if (shouldAdd) {
                newData.push({
                  id: icon.id,
                  type: icon.type,
                  type_name: typeName,
                  image_url: icon.image_url,
                });
              }

              popupForm.change("selected_icons", newData);
            }}
          >
            <FormDataConsumer label="Value" fullWidth>
              {({ formData }) => {
                var isSelected = false;
                if (formData.selected_icons) {
                  for (const i of formData.selected_icons) {
                    if (i.id == icon.id) {
                      isSelected = true;
                      break;
                    }
                  }
                }

                return (
                  <div className="chatroom-icon" style={{ backgroundColor: isSelected ? "red" : "transparent", width: "100%", aspectRatio: 1 }}>
                    <img src={imageUrl} />
                  </div>
                );
              }}
            </FormDataConsumer>
          </Button>
        );
      })}
    </Grid>
  );
};

const PaidIconGrid = ({ typeId, typeName, popupForm }) => {
  const { paidIconPacks } = usePaidIconPacks(typeId);

  return (
    <>
      {paidIconPacks.map((pack) => {
        const name = pack.name;
        const icons = pack.icons;

        return (
          <div style={{ marginBottom: "16px" }}>
            <span>{name}</span>
            <Grid container spacing={1} fullWidth>
              {icons.map((icon) => {
                const imageUrl = icon.purchase_image_info?.unlocked_icon;
                return (
                  <Button
                    key={icon.id}
                    onClick={() => {
                      var oldData = popupForm.getState().values.selected_icons ?? [];
                      var newData = [...oldData];

                      var shouldAdd = true;
                      //Delete the icon if already added before
                      for (var i = 0; i < newData.length; i++) {
                        const d = newData[i];
                        if (d.id == icon.id) {
                          shouldAdd = false;
                          newData.splice(i, 1);
                          break;
                        }
                      }
                      //Add the icon if not added before
                      if (shouldAdd) {
                        newData.push({
                          id: icon.id,
                          type: icon.type,
                          type_name: typeName,
                          pack_id: icon.pack_id,
                          pack_name: pack.name,
                          purchase_image_info: icon.purchase_image_info,
                        });
                      }

                      popupForm.change("selected_icons", newData);
                    }}
                  >
                    <FormDataConsumer label="Value" fullWidth>
                      {({ formData }) => {
                        var isSelected = false;
                        if (formData.selected_icons) {
                          for (const i of formData.selected_icons) {
                            if (i.id == icon.id) {
                              isSelected = true;
                              break;
                            }
                          }
                        }

                        return (
                          <div className="chatroom-icon" style={{ backgroundColor: isSelected ? "red" : "transparent", width: "100%", aspectRatio: 1 }}>
                            <img src={imageUrl} />
                          </div>
                        );
                      }}
                    </FormDataConsumer>
                  </Button>
                );
              })}
            </Grid>
          </div>
        );
      })}
    </>
  );
};

const PopupContent = ({ form, selectedIcons }) => {
  const popupForm = useForm();
  const { types } = useIconPackTypes();

  useEffect(() => {
    popupForm.change("selected_icons", selectedIcons);
  }, []);

  return (
    <>
      {/* sticky header: radio buttons dock to the top of the scrollable area */}
      <div
        style={{
          backgroundColor: "white",
          position: "sticky",
          top: 0,
          zIndex: 10,
          padding: "0px",
        }}
      >
        <RadioButtonGroupInput fullWidth source="type" validate={required()} choices={types.map((type) => ({ id: type.id, name: type.name }))} defaultValue={types.find((type) => !type.is_pay)?.id} />
      </div>

      {/* scrollable content lives in the container that wraps PopupContent in AddIconDialog */}
      <div style={{ paddingTop: 8, paddingBottom: 8 }}>
        <FormDataConsumer>
          {({ formData }) => {
            const type = types.find((type) => type.id == formData.type);
            if (!type) {
              return <></>;
            }
            const isPay = type.is_pay;

            if (!isPay) {
              return <FreeIconGrid typeId={type.id} typeName={type.name} popupForm={popupForm} />;
            } else {
              return <PaidIconGrid typeId={type.id} typeName={type.name} popupForm={popupForm} />;
            }
          }}
        </FormDataConsumer>
      </div>

      {/* sticky footer: toolbar dock to the bottom of the scrollable area */}
      <div
        style={{
          position: "sticky",
          bottom: 0,
          zIndex: 10,
          padding: "0px",
        }}
      >
        <CustomToolbar form={form} />
      </div>
    </>
  );
};

const CustomToolbar = ({ form, ...props }) => {
  const popupForm = useForm();

  const onSave = async () => {
    const values = popupForm.getState().values;

    // //Check if any icon has already added before
    // var alreadySelected = false;
    // for (const selectedIcon of selectedIcons) {
    //   for (const i of values.selected_icons) {
    //     if (selectedIcon.id == i.id) {
    //       alreadySelected = true;
    //       break;
    //     }
    //   }
    // }

    // if (alreadySelected) {
    //   notify("Already Selected this Icon", "error");
    //   return;
    // }

    // var oldData = form.getState().values.icons ?? [];
    // var newData = [...oldData]; //Clone

    //Add enabled:true to all newData

    const newData = [];
    for (const i of values.selected_icons) {
      newData.push({
        ...i,
        enabled: i.enabled ?? true,
      });
    }
    // newData.push({ id: values.id, image_url: values.image_url, enabled: true });

    form.change("icons", newData);

    cleanPopupForm(popupForm);
    PopupboxManager.close();
  };

  return (
    <Toolbar {...props}>
      <Button
        onClick={() => {
          cleanPopupForm(popupForm);
          PopupboxManager.close();
        }}
        label="Close"
      ></Button>
      {/* <SaveButton onSave={handleSave} label="Save" /> */}
      <SaveButton
        label="Save"
        handleSubmitWithRedirect={async () => {
          await onSave();
        }}
      />
    </Toolbar>
  );
};

const cleanPopupForm = () => {
  //   popupForm.change("set_name", undefined);
  //   popupForm.change("voting_question", undefined);
  //   popupForm.change("canned_message_start_time", undefined);
  //   popupForm.change("canned_message_end_time", undefined);
  //   popupForm.change("canned_messages", undefined);
  //   popupForm.change("voting_enabled", undefined);
};

export const AddIconDialog = ({ form, selectedIcons }) => {
  return (
    <SimpleForm toolbar={null}>
      <PopupContent form={form} selectedIcons={selectedIcons} />
    </SimpleForm>
  );
};
